import { gql } from '@apollo/client';

export const READ_RECEIPT_WITH_SALES_ORDER = gql`
  query ReadReceiptByTransactionId($transactionId: ID!) {
    readReceiptByTransactionId(transactionId: $transactionId) {
      items {
        amountCents
        endTime
        startTime
        type
        licensePlate
        vatAmount
        vatPercentage
        amountExclVAT
        parkingSessionId
        zoneName
        zoneCode
        zoneUid
      }
      countryCode
      id
      creditCard {
        cardId
        paymentMethod
      }
      transactionId
      created
      orderNumber
      subMerchant {
        subMerchantName
      }
      salesOrder {
        uid
        creditCardId
        orderStatus
        endDate
        attachments {
          uid
          fileName
          mimeType
          sizeBytes
        }
        orderLines {
          pmcId
          salesOrderStatus
          orderLineId
          salesOrderId
          lineTotal
          version
          quantity
          lineVatAmount
          billingFrequency
          billingType
          status
          registrationPlates {
            plateText
            countryCode
          }
          parkingSpace {
            name
          }
          charge {
            validity {
              validFrom
              validTo
            }
          }
          validity {
            validFrom
            validTo
          }
          pmc {
            name
            physicalZoneUid
            attachmentPolicy
            parkZone {
              name
              locationType
              commercialZoneView {
                name
                zoneCode
              }
              address {
                street
                marker
                number
                city
              }
              info {
                doorCode
              }
            }
          }
        }
        renewal
        isRenewalDisabled
        scheduledTerminationDate
      }
    }
  }
`;
